export enum HttpMethods {
  Get = "GET",
  Post = "POST",
  Put = "PUT",
  Delete = "DELETE",
}

export type HttpMethod = `${HttpMethods}`;
